// extracted by mini-css-extract-plugin
export default {"content":"src-views-analytics-components-SpotlightKPIs-SpotlightKPIs__content--xrgKR"};